import { useContext } from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import AppContext from "../../../../AppContext";
import AppointmentNoteContentBuilder, {
  AppointmentNoteTagProps
} from "../../../Notes/Compositions/AppointmentNoteContentBuilder";
import IReservation from "../../../Types/IReservation";
import { IConfirmedAppointmentResponse } from "../Components/ConfirmationStepWrapper";
import useConfirmOpsAppointmentWithDistance from "../Hooks/UseConfirmOpsAppointmentWithDistance";
import useCreateLeadResult from "../Hooks/UseCreateLeadResult";

/** A composed hook used to confirm an appointment. */
const AppContextUseConfirmAppointment: TriggeredHook<IConfirmedAppointmentResponse, IReservation, boolean> = () => {
  const { defaultCenter, customerCState, leadIdCState, medicalConclusions, reservation } = useContext(AppContext);
  return useConfirmOpsAppointmentWithDistance({
    useCreateLeadResult,
    noteProps: {
      customer: customerCState,
      medicalConclusions,
      reservation: reservation!,
      center: defaultCenter
    } as AppointmentNoteTagProps,
    noteContentBuilder: AppointmentNoteContentBuilder,
    customer: customerCState,
    leadId: leadIdCState
  });
};

export default AppContextUseConfirmAppointment;
